module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/no_games_basketball-2b641cec07c4d09afa629f20935e1c79.svg";